module.exports = __webpack_public_path__ + "static/media/accessibility-white.cbf98538.svg";